/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Standing_Idp_DisabledInputs */



/**
* | output |
* | --- |
* | "Your identity provider has switched this member off. This cannot be undone from oneAI — reactivate them in your identity provider instead." |
*
* @param {Member_Detail_Standing_Idp_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_standing_idp_disabled = /** @type {((inputs?: Member_Detail_Standing_Idp_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Standing_Idp_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Identitätsanbieter hat dieses Mitglied abgeschaltet. Das lässt sich nicht in oneAI aufheben — reaktivieren Sie das Mitglied stattdessen in Ihrem Identitätsanbieter.")
	return /** @type {LocalizedString} */ ("Your identity provider has switched this member off. This cannot be undone from oneAI — reactivate them in your identity provider instead.")
});